<div class="img" *ngIf="reInit" [formGroup]="group">
    <div class="title" *ngIf="field?.label">
        <h2 class="image-field-label">
            {{ field.label | titlecase }}
        </h2>
    </div>

    <div class="image-gallery-container" *ngIf="filteredImages.length > 0; else noRecords">
        <div class="image-gallery-grid">
            <div class="image-item-card" *ngFor="let image of filteredImages" [class.selected]="isSelected(image.value)"
                (click)="setValue(image.value)">
                <div class="image-wrapper">
                    <img [alt]="field.customfield3 || 'Uploaded Image'" [src]="serverPath + image.image + cid" />
                </div>
                <div class="selection-check" *ngIf="isSelected(image.value)">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <!-- <div style="position: relative; width: 100%;">
        <input #searchInput
            style="width: 100%;height: 50px;margin-bottom: 15px;border: 1px solid #c6c4c4;border-radius: 5px; padding-left: 5px;"
            type="text" placeholder="{{ field.name | titlecase }}" (input)="onSearch($event.target.value)" />
        <mat-icon style="position: absolute;right: 10px;top:40%;transform: translateY(-50%);cursor: pointer;">search
        </mat-icon>
    </div> -->

                <!-- <div fxLayoutAlign="center center" *ngIf="filteredImages.length === 0" style="font-size: 20px;">
        No records found
    </div> -->

                <!-- <div class="pointer" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center"
                    *ngIf="filteredImages.length > 0; else noRecords">
                    <div fxLayout="row wrap" fxFlex="100" fxLayoutGap="10px" class="gapbottom">
                        <div fxFlex.xs="50" fxFlex="25" *ngFor="let image of filteredImages">
                            <img style="width: 100%;" (click)="setValue(image.value, searchInput)"
                                [alt]="field.customfield3" [src]="serverPath + image.image + cid" />
                        </div>
                    </div>
                </div> -->

                <ng-template #noRecords>
                    <div class="no-records-msg">
                        No records found
                    </div>
                </ng-template>
            </div>